export default __webpack_public_path__ + "static/media/ss_railing.c50159aa.jpeg";